import Vue from 'vue';
import { ErrorApi } from '@/core/api/ErrorApi';

const defaultGroup = 'app';
const defaultSpeed = 800;
const defaultDuration = 2000;


const error = (message: string, title: string = '') => {
  const options = {
    group: defaultGroup,
    type: 'error',
    title,
    text: message,
    duration: 5000,
    speed: defaultSpeed,
  };
  Vue.notify(options);
};

const errorApi = (apiError: ErrorApi) => {
  const options = {
    group: defaultGroup,
    type: 'error',
    title: `API error ${apiError.code ? ` code: ${apiError.code}` : ''}`,
    text: apiError.message,
    duration: 5000,
    speed: defaultSpeed,
  };
  // console.log(apiError);
  Vue.notify(options);
};

const warning = (message: string, title: string = '') => {
    const options = {
      group: defaultGroup,
      type: 'warn',
      title,
      text: message,
      duration: defaultDuration,
      speed: defaultSpeed,
    };
    Vue.notify(options);
  };

const success = (message: string, title: string = '') => {
    const options = {
      group: defaultGroup,
      type: 'success',
      title,
      text: message,
      duration: defaultDuration,
      speed: defaultSpeed,
    };
    Vue.notify(options);
  };

export default {
  error,
  errorApi,
  warning,
  success,
};
